export default [
  {
    path: '/otherSystem/card',
    name: 'card',
    component: () => {
      return import(
        /* webpackChunkName: "otherSystem" */ '@/views/otherSystem/card.vue'
      )
    },
    meta: {
      title: ''
    }
  },
  {
    path: '/otherSystem/happiness-life',
    name: 'happinessLife',
    component: () => {
      return import(
        /* webpackChunkName: "otherSystem" */ '@/views/otherSystem/happiness-life/index.vue'
      )
    },
    meta: {
      title: '幸福人寿卡号查询'
    }
  }
]
